import { InjectionToken } from '@angular/core';

export interface CfbIntegrationStatePort {
  setIntegrationOn(isIntegrationOn: boolean): void;
}

export const CFB_INTEGRATION_STATE_PORT =
  new InjectionToken<CfbIntegrationStatePort>('CFB_INTEGRATION_STATE_PORT');
